export class UserIdReq {
    userId:number
}